import React, { Component } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import Contact from "components/ContactLogo/ContactLogo";
import StatusTrack from "components/ContactLogo/StatusTrack";
import MaintenancePage from "../MaintenancePage/MaintenancePage";
// reactstrap components
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import ContactUs from "components/ContactUS/ContactUs";
import StatusTrackForm from "components/ContactUS/StatusTrackForm";
import Contactuspage from "components/Contactuspage/Contactuspage";
import MainNav from "./MainNav";
class TopNavbar extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggleNavbar.bind(this);

    this.state = {
      isOpen: false,
      open: false,
      maintenancePage: false,
      trackStatus: false,
    };

    if (typeof window !== "undefined") {
      window.onscroll = function () {
        let pageScrollpos = window.pageYOffset;
        if (pageScrollpos > 85) {
          document
            .getElementById("header-global")
            .classList.add("fixed-white-bg");
        } else {
          const el = document.getElementById("header-global");
          if (el.classList.contains("fixed-white-bg")) {
            el.classList.remove("fixed-white-bg");
          }
        }
      };
    }
  }

  state = {
    isOpen: false,
  };

  toggleNavbar() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  toggleContactUs = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  openContactUs = () => {
    this.setState({
      open: true,
    });
  };
  openMaintenancePage = () => {
    this.setState({
      maintenancePage: !this.state.maintenancePage,
    });
  };
  opentrackStatus = () => {
    this.setState({ trackStatus: true });
  };
  closetrackStatus = () => {
    this.setState({ trackStatus: false });
  };
  // toggleTrackStatus = () => {
  //   this.setState({ trackStatus: !this.state.trackStatus });
  // };
  /*freshChatClick() {
      console.log("event trigger");
  }*/

  render() {
    return (
      <>
        <header className="header-global" id="header-global">
          <div className="container px-0">
            <Navbar id="navbar" className="topNav px-0" expand="lg">
              <NavbarBrand href="/">
                <img
                  id="logo-white"
                  alt="Safexpay"
                  src={require("assets/img/logos/logo_wh.png")}
                  className="white-logo"
                />
                <img
                  id="logo-color"
                  alt="Safexpay"
                  src={require("assets/img/logos/logo.png")}
                  className="color-logo"
                />
              </NavbarBrand>
              <NavbarToggler
                className="mr-2"
                onClick={() => this.setState({ isOpen: true })}
              />
              {!this.state.isOpen && (
                <Collapse isOpen={this.state.isOpen} navbar>
                  <div className="nav-dropdown ml-lg-auto">
                    <MainNav />
                  </div>
                </Collapse>
              )}
              {this.state.isOpen && (
                <Collapse isOpen={this.state.isOpen} navbar>
                  <div className="nav-dropdown ml-lg-auto">
                    <NavbarToggler
                      className="mr-2"
                      onClick={() => this.setState({ isOpen: false })}
                    />
                    <MainNav />
                  </div>
                </Collapse>
              )}
            </Navbar>
          </div>
        </header>
        <StatusTrack
          click={this.opentrackStatus}
          flag={this.state.trackStatus || this.state.open}
          disableButton={this.state.open}
        />
        {/* <Contact
          click={this.toggleContactUs}
          flag={this.state.open || this.state.trackStatus}
          disableButton={this.state.trackStatus}
        /> */}
        {/* <ContactUs open={this.state.open} click={this.toggleContactUs} /> */}
        <StatusTrackForm
          open={this.state.trackStatus}
          click={this.closetrackStatus}
        />
        <MaintenancePage
          open={this.state.maintenancePage}
          close={this.openMaintenancePage}
        />
      </>
    );
  }
}

export default TopNavbar;
